/**
 * Sometimes we need to skip some logic if unit-test
 * Only works for JEST
 * @returns
 */
export function isUnitTest() {
  return import.meta.env.JEST_WORKER_ID !== undefined
}
